import service from '@/utils/server';
const modName='/toxin/toxinExemptSetting/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};

//编辑提交
export const editData = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};
//新增提交
export const addData = data => {
  return service({
    url: modName + 'batchAdd',
    method: 'post',
    data
  });
};

//查询粮原地列表
export const originDetails = data => {
  return service({
    url: modName + 'originDetails',
    method: 'post',
    data
  });
};





// WEBPACK FOOTER //
// ./src/page/toxin/toxinExemptSetting/api/index.js